var map = {
	"./data": 38024,
	"./data.ts": 38024,
	"./img/arxiv_icon.svg": 59168,
	"./img/crossref_icon.svg": 79823,
	"./img/doi_icon.svg": 88066,
	"./img/gnd_icon.svg": 88929,
	"./img/grid_icon.png": 42861,
	"./img/hbz_icon.gif": 81578,
	"./img/isbn_icon.svg": 91902,
	"./img/ismn_icon.gif": 28653,
	"./img/isni_icon.gif": 43911,
	"./img/issn_icon.svg": 33431,
	"./img/openAlex_icon.svg": 88610,
	"./img/orcid_icon.svg": 45973,
	"./img/pmid_icon.png": 40835,
	"./img/ringgold_icon.png": 2641,
	"./img/ror_icon.svg": 47001,
	"./img/scopus_icon.svg": 74771,
	"./img/wos_icon.png": 35546,
	"./img/zdb_icon.png": 62293,
	"Settings/externs/data": 38024,
	"Settings/externs/data.ts": 38024,
	"Settings/externs/img/arxiv_icon.svg": 59168,
	"Settings/externs/img/crossref_icon.svg": 79823,
	"Settings/externs/img/doi_icon.svg": 88066,
	"Settings/externs/img/gnd_icon.svg": 88929,
	"Settings/externs/img/grid_icon.png": 42861,
	"Settings/externs/img/hbz_icon.gif": 81578,
	"Settings/externs/img/isbn_icon.svg": 91902,
	"Settings/externs/img/ismn_icon.gif": 28653,
	"Settings/externs/img/isni_icon.gif": 43911,
	"Settings/externs/img/issn_icon.svg": 33431,
	"Settings/externs/img/openAlex_icon.svg": 88610,
	"Settings/externs/img/orcid_icon.svg": 45973,
	"Settings/externs/img/pmid_icon.png": 40835,
	"Settings/externs/img/ringgold_icon.png": 2641,
	"Settings/externs/img/ror_icon.svg": 47001,
	"Settings/externs/img/scopus_icon.svg": 74771,
	"Settings/externs/img/wos_icon.png": 35546,
	"Settings/externs/img/zdb_icon.png": 62293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 347;